import { render, staticRenderFns } from "./register.vue?vue&type=template&id=be872478&scoped=true&"
var script = {}
import style0 from "./register.vue?vue&type=style&index=0&id=be872478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be872478",
  null
  
)

export default component.exports